<template>
  <div>customer_service</div>

</template>

<script>
  export default {
    name: 'customer_service_index',
    methods:{
    },
    components:{
    },
    mounted(){
    }
  }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/set_link/components/customer_service.vue